import * as actionTypes from './actions'
import api from './api';

export const onReceiveFromNotificationChannel = (data) => {
  switch (data.action) {
    case "new_chatroom":
      return {
        type: actionTypes.NOTIFICATION_NEW_CHATROOM,
        payload: data
      }
    case "add_notification":
      return {
        type: actionTypes.ADD_NOTIFICATION,
        payload: data.payload
      }
    case "remove_notification":
      return {
        type: actionTypes.REMOVE_NOTIFICATION,
        payload: data.payload
      }
    default:
      return {
        type: actionTypes.NOTHING
      }
  }
}

export const fetchNotifications = () => {
  return async dispatch => {
    try {
      const resp = await api.fetchNotifications()
      if (resp.data.status === "success") {
        dispatch({
          type: actionTypes.INIT_NOTIFICATIONS,
          payload: {
            notifications: resp.data.notifications,
          }
        })
      }
    } catch(error) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/notificationActionCreators.js